import script from "./ScoreWidgetExtended.vue?vue&type=script&setup=true&lang=js"
export * from "./ScoreWidgetExtended.vue?vue&type=script&setup=true&lang=js"

import "./ScoreWidgetExtended.vue?vue&type=style&index=0&id=7d02eeab&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d02eeab"]])

export default __exports__